export const OUTCOME_SALES_AD_LIMIT = 150;
export const FETCH_CREATIVE_ADS_PAGINATION_LIMIT = 10;
